import React from 'react';
import { Package, CheckCircle } from 'lucide-react';
import { MINERALS_METALS } from '../data/mockData';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

const MineralsMetals = () => {
  return (
    <div className="page-container">
      {/* Page Header */}
      <section className="page-header-section">
        <div className="section-container">
          <h1 className="page-title">Minerals & Metals</h1>
          <p className="page-subtitle">
            Premium-grade metals and minerals for global industries
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="products-section">
        <div className="section-container">
          <div className="products-grid">
            {MINERALS_METALS.map((product) => (
              <Card key={product.id} className="product-card">
                <CardHeader>
                  <div className="product-card-icon">
                    <Package size={28} />
                  </div>
                  <CardTitle className="product-card-title">{product.name}</CardTitle>
                  <CardDescription className="product-card-description">
                    {product.shortDesc}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="product-specs">
                    {product.purity && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Purity:</span>
                        <span className="product-spec-value">{product.purity}</span>
                      </div>
                    )}
                    {product.grade && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Grade:</span>
                        <span className="product-spec-value">{product.grade}</span>
                      </div>
                    )}
                    {product.content && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Content:</span>
                        <span className="product-spec-value">{product.content}</span>
                      </div>
                    )}
                    {product.type && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Type:</span>
                        <span className="product-spec-value">{product.type}</span>
                      </div>
                    )}
                    {product.standard && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Standard:</span>
                        <span className="product-spec-value">{product.standard}</span>
                      </div>
                    )}
                    {product.forms && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Forms:</span>
                        <span className="product-spec-value">{product.forms}</span>
                      </div>
                    )}
                    {product.formula && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Formula:</span>
                        <span className="product-spec-value">{product.formula}</span>
                      </div>
                    )}
                    {product.isotope && (
                      <div className="product-spec-item">
                        <Badge variant="destructive" className="product-warning-badge">
                          {product.note}
                        </Badge>
                      </div>
                    )}
                  </div>
                  {product.applications && (
                    <div className="product-applications">
                      <h4 className="product-applications-title">Key Applications:</h4>
                      <ul className="product-applications-list">
                        {product.applications.slice(0, 3).map((app, index) => (
                          <li key={index} className="product-application-item">
                            <CheckCircle size={14} className="product-check-icon" />
                            {app}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="info-section">
        <div className="section-container">
          <div className="info-card">
            <h2 className="info-title">Supply & Logistics</h2>
            <p className="info-text">
              We support bulk orders with flexible contract terms (FOB / CIF) and provide 
              worldwide shipping. Our experienced team ensures smooth coordination from 
              sourcing to final delivery.
            </p>
            <div className="info-features">
              <div className="info-feature">
                <CheckCircle className="info-feature-icon" />
                <span>Verified quality assurance</span>
              </div>
              <div className="info-feature">
                <CheckCircle className="info-feature-icon" />
                <span>Competitive international pricing</span>
              </div>
              <div className="info-feature">
                <CheckCircle className="info-feature-icon" />
                <span>Transparent documentation</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MineralsMetals;
